import * as React from "react";
import * as Modal from 'react-modal';
import { ScaleLoader } from 'react-spinners';

export class Spinner extends React.Component {

    public render() {

        return (
            <div>
                <Modal
                    ariaHideApp={false}
                    isOpen={true}
                    style={{
                        content: {
                            backgroundColor: "transparent",
                            border: "none",
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            marginRight: '-50%',
                            transform: 'translate(-50%, -50%)',
                            maxWidth: '1200px',
                            maxHeight: window.innerHeight - 100
                        }
                    }}>

                    <ScaleLoader
                        sizeUnit={"px"}
                        size={300}
                        color={'#0098db'}
                        loading={true} />

                </Modal>
            </div>
        );

    }

}


// WEBPACK FOOTER //
// ./src/component/common/Spinner.tsx